module.exports = __webpack_public_path__ + "static/dyes_cash_reward_banner_img-ca21ec986c54584c3af98ef678be7b0a.png";